<template>
<div>
    <el-input @change="changed" v-model="formula"></el-input>
    <div style="font-size:smaller;">
        <div>Examples:</div>
        <div style="font-family:monospace;">
            <ul>
                <li>map("URL to Content Type",`address_normalized`)</li>
            </ul>
        </div>
        <div>General principles:</div>
        <ul>
            <li>Use backticks (`) to reference fields</li>
            <li>Use double quotes (") for strings and map names</li>
            <li>You can nest functions within functions similar to Excel</li>
        </ul>
        <div>Functions:</div>
        <div style="font-family:monospace;">
            and, avg, case, char_count, concat, counta, if, ifnull, map, min, max, or, regex,
            regexall, sum, word_count
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "FormulaEditor",
    data() {
        return {
            formula: '',
        }
    },
    methods: {
        changed() {
            this.$emit('change_formula',this.formula)
            axios.post('/stop_showing_this_tour/' + this.tour_to_actually_show)
                .then(response => {
                    // console.log("just completed flattening")
                    console.log('successfully stopped')
                    // console.log('About to get dispositions')
                })
                .catch(error => {
                    console.log('did not successfully stop')
                })
        },
    },
}
</script>

<style scoped>

</style>